import * as React from 'react';
import { observer } from 'mobx-react';
import DummyImage from './images/course_dummy_img.png';
import './dummyImageBlockContent.module.scss';

export const DummyImageBlockContentPane = observer(
  class DummyImageBlockContentPane extends React.Component {
    render() {
      return (
        <div className="dummy-image" styleName="image-wrapper" data-testid="dummy-image">
          <img src={DummyImage} />
        </div>
      );
    }
  }
);
